<template>
    <router-view v-if="init"> </router-view>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { EventBus } from "./store/event-bus";

  export default {
    components:{},
    data() {
      return {
        init: false
      }
    },
    methods: {
      ...mapActions([
        'fetchAccount', 'fetchGuests', 'setToken', 'fetchAps',
        'fetchPosts', 'fetchInvoices', 'fetchNewGuestsMonthlyStats',
        'fetchCountryGuestsStats', 'fetchLanguageGuestsStats',
        'fetchGalleryMedias', 'fetchConfig', 'fetchCountries',
        'fetchLanguages', 'fetchTemplates', 'fetchNotifications',

        // Admin
        'fetchCompanies',

        // Reseller
        'fetchResellerAps'
      ]),
      initialize() {
        this.init = true;
        this.setToken(localStorage.getItem('token'));
        this.setLoading(true);

        this.fetchAccount()
          .then(() => {
            this.fetchGuests()
            this.fetchNewGuestsMonthlyStats()
            this.fetchCountryGuestsStats()
            this.fetchLanguageGuestsStats()
            this.fetchPosts()
            this.fetchInvoices()
            this.fetchConfig()
            this.fetchGalleryMedias()
            this.fetchTemplates()

            this.fetchAps()
            this.fetchCountries()
            this.fetchLanguages()
            this.fetchNotifications()

            if (this.account.role === 'admin') {
              this.fetchCompanies()
            }

            if (this.account.role === 'reseller') {
              this.fetchResellerAps()
            }

            if (process.env.NODE_ENV === 'production') {
              if (this.company && this.company.id > 4) {
                FS.identify(this.company.id, { name: this.company.name, email: this.company.email });
              } else if (this.account.id > 9) {
                FS.identify(this.account.id, { name: this.account.username, email: this.account.username });
              } else {
                FS.shutdown();
              }
              FS.consent(true);
            } else {
              FS.shutdown();
            }

            EventBus.$off('companyChanged');
            EventBus.$on('companyChanged', this.initialize);
            this.setLoading(false);
          });
      }
    },
    created () {
      if (this.$route && this.$route.name) {
        if (localStorage.getItem('role') && !['admin', 'reseller', 'client'].includes(localStorage.getItem('role'))) {
          localStorage.removeItem('role');
          localStorage.removeItem('token');
          localStorage.removeItem('CompanyId');
        }

        if (!localStorage.getItem('token') && this.$route.name && this.$route.name.indexOf('Auth') !== -1) {
          this.init = true;
          return this.$router.push('/auth/')
        } else this.initialize();
      }
    },
    watch: {
      '$route.name'(nv) {
        if (localStorage.getItem('role') && !['admin', 'reseller', 'client'].includes(localStorage.getItem('role'))){
          localStorage.removeItem('role');
          localStorage.removeItem('token');
          localStorage.removeItem('CompanyId');
        }

        if (!this.init) {
          if (!localStorage.getItem('token') && nv && nv.indexOf('Auth') !== -1 && !this.$route.query.h) {
            this.init = true;
            return this.$router.push('/auth/')
          } else this.initialize();
        }
      }
    },
  }
</script>
<style>
  .snackbar {
    z-index: 100;
  }
  .recaptcha-div div {
    margin: 0 auto!important;
  }
</style>
